// src/shared/lib/storesRegistry.ts

export type ClearFunction = () => void;

const clearFunctions = new Set<ClearFunction>();

/**
 * Registers a function that clears the state of a store
 */
export const registerClear = (clearFn: ClearFunction) => {
  clearFunctions.add(clearFn);
};

/**
 * Executes all registered cleaning functions.
 */
export const clearAllStores = () => {
  clearFunctions.forEach((fn) => fn());
  clearFunctions.clear();
};
